import { render } from "./PaginatorComponent.vue?vue&type=template&id=26a2f0f8&scoped=true&ts=true"
import script from "./PaginatorComponent.vue?vue&type=script&lang=ts"
export * from "./PaginatorComponent.vue?vue&type=script&lang=ts"

import "./PaginatorComponent.vue?vue&type=style&index=0&id=26a2f0f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a2f0f8"]])

export default __exports__